import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';


@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [],
})
export class NotificationComponent {
    readonly data: any = inject(MAT_SNACK_BAR_DATA);
    readonly snackRef = inject(MatSnackBarRef<NotificationComponent>);

    dismissMessage() {
        this.snackRef.dismiss();
    }
}
